import { render, staticRenderFns } from "./zw-steps.vue?vue&type=template&id=00650a6a&scoped=true"
import script from "./zw-steps.vue?vue&type=script&lang=js"
export * from "./zw-steps.vue?vue&type=script&lang=js"
import style0 from "./zw-steps.vue?vue&type=style&index=0&id=00650a6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00650a6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00650a6a')) {
      api.createRecord('00650a6a', component.options)
    } else {
      api.reload('00650a6a', component.options)
    }
    module.hot.accept("./zw-steps.vue?vue&type=template&id=00650a6a&scoped=true", function () {
      api.rerender('00650a6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/zw-steps.vue"
export default component.exports